import Model from "../../classes/model/Model";
import User from "./User";
import Direction from "./Direction";
import ScheduleReplace from "./ScheduleReplace";
import qs from "qs";

/**
 * @property {int} id
 * @property {int} is_delete
 * @property {int} old_id
 * @property {int} company_id
 * @property {int} group_id
 * @property {int} filiation_id
 * @property {int} fitness_room_id
 * @property {int} trainer_id
 * @property {int} direction_id
 * @property {int} difficulty_id
 * @property {string} date
 * @property {string} time_start
 * @property {string} time_end
 * @property {int} capacity
 * @property {int} fill
 * @property {int} set_
 * @property {int} rented
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Direction} direction
 * @property {User} creator
 * @property {User} updater
 * @property {ScheduleReplace} reason
 */
export default class Schedule extends Model {

    relations() {
        return {
            direction: {class: Direction, many: false},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
            reason: {class: ScheduleReplace, many: false},
        };
    }


    static setRented(scheduleId, rented) {

        return Schedule.getAxios().get(Schedule.getUrlV1('schedule/rented'), {
            params: {
                id: scheduleId,
                rented: rented
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            // for (let trainer of response.data) {
            //     data.push(new Visit(trainer));
            // }
            return {data, headers: response.headers};
        });
    }

}
